import { Box, Grid, Link, Typography, Stack, useMediaQuery, Theme } from "@mui/material"
import { ArrowBackRounded } from "@mui/icons-material"
import { useDynamicDataMutation } from "../../../../api/dynamicSites/hooks"
import useActivationObject from "../../../providers/ActivationObjectProvider/hooks/useActivationObject"
import { DynamicRequestBody } from "../../../../api/dynamicSites/types"
import { WizardStepType } from "../../../providers/ActivationObjectProvider/types"
import { useCallback } from "react"
import { useLocation } from "react-router-dom"

const Footer = () => {
    const { data: activationObject } = useActivationObject()
    const year = new Date().getFullYear()
    const isPortableDevice = useMediaQuery((theme: Theme) => theme.breakpoints.down("md"))
    const { pathname } = useLocation()

    const { mutate: mutateDynamicData } = useDynamicDataMutation()

    const handleStepBack = useCallback(() => {
        if (activationObject) {
            const dynamicBody = {
                synonym: activationObject.synonym,
                type: "Redirect",
                mainSite: activationObject.previousWizardStep.mainStep,
                dynamicSiteNumber: activationObject.previousWizardStep.subStep,
            } as DynamicRequestBody

            mutateDynamicData(dynamicBody)
        }
    }, [activationObject, mutateDynamicData])

    const footerHiddenStates: WizardStepType[] = ["SimpleInfo", "Finish"]
    const hideBackButton = (activationObject && footerHiddenStates.includes(activationObject?.actualWizardStep.mainStep)) || pathname === "/"

    return (
        <>
            {!hideBackButton && (
                <Box className="relative">
                    <Box className="container mb-9 relative">
                        <Link
                            component="button"
                            className=" text-pantone-black-50"
                            underline="none"
                            onClick={() => {
                                handleStepBack()
                            }}
                        >
                            <Stack direction="row" spacing="0.25rem">
                                <ArrowBackRounded className="text-lg md:text-2xl" />
                                <Typography className="text-sm md:text-base">Přejít zpět</Typography>
                            </Stack>
                        </Link>
                    </Box>
                    {/* <span className='absolute inline-block h-px w-[calc(4.5rem+10vw)] mb-9 bottom-0 right-0 bg-pantone-gray-1'></span> */}
                </Box>
            )}
            <Box component="footer" className="bg-pantone-gray-2 px-4">
                <Box className="container py-6">
                    <Grid container fontSize="inherit" className=" text-xs lg:text-sm text-pantone-black-10" spacing={2}>
                        <Grid item xs={12} sm={6}>
                            <Stack className="text-inherit gap-1" fontSize="inherit" direction={isPortableDevice ? "column" : "row"}>
                                <Link
                                    href="https://www.bezpecnostnicentrum.cz/file/edee/2020/11/f-17-10-03_vseobecne-obchodni-podminky_ucinne-od-31_10_2020.pdf"
                                    color="inherit"
                                >
                                    Všeobecné obchodní podmínky
                                </Link>
                                <span
                                    className='lg:h-full h-px w-2 lg:w-[2px] inline-block before:content-[""] before:h-full before:inline-block before:bg-pantone-black-10 mt-[0.267rem] mb-[0.125rem] lg:my-0 lg:mx-4'
                                    style={{ background: "#dcdcda" }}
                                ></span>
                                <Link
                                    href="https://www.bezpecnostnicentrum.cz/file/edee/2018/05/f-18-09-zasady-zpracovani-osobnich-udaju.pdf"
                                    color="inherit"
                                >
                                    Zásady o zpracování osobních údajů
                                </Link>
                            </Stack>
                        </Grid>
                        <Grid item xs={12} sm={6} textAlign={isPortableDevice ? "left" : "right"}>
                            <Stack
                                className="text-inherit"
                                fontSize="inherit"
                                direction="row"
                                alignItems="center"
                                justifyContent={isPortableDevice ? "flex-start" : "flex-end"}
                                spacing={isPortableDevice ? 1 : 2}
                            >
                                <strong>{year} © Jablotron</strong>
                                <span
                                    className='h-2 lg:h-full w-px lg:w-[2px] inline-block before:content-[""] before:h-full before:inline-block before:bg-pantone-black-10'
                                    style={{ background: "#dcdcda" }}
                                ></span>
                                <Typography fontSize="inherit" color="inherit">
                                    Vytvořil{" "}
                                    <Link href="https://nexum.cz" color="inherit">
                                        Nexum.cz
                                    </Link>
                                </Typography>
                            </Stack>
                        </Grid>
                    </Grid>
                </Box>
            </Box>
        </>
    )
}

export default Footer
